import { DeploymentUnitStatus } from '@agilelab/plugin-wb-builder-common';
import { snakeCaseToTitleCase } from '@agilelab/plugin-wb-platform-common';
import { Skeleton } from '@material-ui/lab';
import { FC, useEffect } from 'react';
import { DeploymentStatusBadge } from '../common';
import { useReleaseDetailPageContext } from './context/useReleaseDetailPageContext';
import { useReleaseStatusAndVersion } from './hooks/useReleaseStatusAndVersion';
import { Label } from './Label';

interface Props {
  status?: DeploymentUnitStatus;
  version?: string;
  environment: string;
}
// component used in the release detail page to show the deployment status of the release and data product,
// this version has the same logic of the DeploymentStatusBadge but with a different tooltip and label, so we created a new component to avoid adding logic to the common one
export const DeploymentChip: FC<Props> = ({ status, environment, version }) => {
  const titleTooltip = `${snakeCaseToTitleCase(status?.toLowerCase() ?? '')} ${
    version ?? ''
  } in ${environment}`;

  return (
    <DeploymentStatusBadge
      status={status}
      version={version}
      tooltipTitle={titleTooltip}
      showVersion
      label={snakeCaseToTitleCase(environment)}
    />
  );
};

export const ReleaseDeploymentStatus: FC = () => {
  const {
    fetchDeploymentUnitStatus,
    deploymentUnitStatusState,
    environment,
    queryParamEnvironment,
  } = useReleaseDetailPageContext();

  useEffect(() => {
    fetchDeploymentUnitStatus();
  }, [fetchDeploymentUnitStatus]);

  const statusAndVersions = useReleaseStatusAndVersion();

  if (deploymentUnitStatusState.loading) return <Skeleton width={150} />;

  return (
    <>
      {statusAndVersions &&
        statusAndVersions.map((statusAndVersion, index) => {
          return (
            <Label
              key={index}
              title={index === 0 ? 'Release Status' : 'Data Product Status'}
            >
              <DeploymentChip
                status={statusAndVersion.status}
                environment={queryParamEnvironment || environment.name}
                version={statusAndVersion.version}
              />
            </Label>
          );
        })}
    </>
  );
};
